export const NAME = 'appointmentCase';